import * as angular from 'angular';
import * as moment from 'moment';

export interface IInterval {
    interval: angular.IIntervalService;
    intervalTime: number;
    callBack: Function;
    start(): void;
    destroy(): void;
    stop: any;
}

// encapsulate interval service
export class Interval implements IInterval {
    stop: any = null;
    interval: angular.IIntervalService = null;
    intervalTime: number = null;
    callBack: Function;

    constructor(callBack: () => void, $interval: angular.IIntervalService, intervalTime = 60 * 1000) {
        this.interval = $interval;
        this.intervalTime = intervalTime;
        this.callBack = callBack;
    }

    private trigger(): void {
        if (this.callBack) {
            try {
                this.callBack();
            } catch (err) {
                console.log(err);
            }
        }
    }

    public start(): void {
        if (!this.stop) {
            this.stop = this.interval(angular.bind(this, this.trigger), this.intervalTime);
        }
    }

    public destroy(): void {
        if (angular.isDefined(this.stop)) {
            this.interval.cancel(this.stop);
            this.callBack = null;
            this.stop = undefined;
        }
    }
}

export default angular
    .module('intervalFactory', [])
    .factory('intervalFactory', ["$interval", ($interval: angular.IIntervalService) => {
        return Interval;
    }])
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/interval.factory.ts